var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew333({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 3.7,
    width: 15,
    height: 8.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.21,5.78H6.62v.48H4.79V7.75H6.48v.48H4.79v2H4.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8,5.78v4.47H7.45V5.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9,5.83a7.71,7.71,0,0,1,1.11-.08,1.86,1.86,0,0,1,1.26.37,1.22,1.22,0,0,1,.39.93,1.3,1.3,0,0,1-.35,1,1.81,1.81,0,0,1-1.36.49,2.17,2.17,0,0,1-.47,0v1.79H9ZM9.61,8a2.14,2.14,0,0,0,.48,0c.7,0,1.12-.34,1.12-1s-.42-.88-1.06-.88a2.16,2.16,0,0,0-.54,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew333);
export default __webpack_public_path__ + "static/media/Symbolpack_New_333.47ccda50ea640fd24630d6668cba0df9.svg";
export { ForwardRef as ReactComponent };